var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-form",
    { attrs: { form: _vm.form } },
    [
      _c(
        "a-form-item",
        { attrs: { label: "Partner Name" } },
        [
          _c("a-input", {
            attrs: { autocomplete: "off", trim: "", type: "text" },
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex gap-5" },
        [
          _c(
            "a-form-item",
            { attrs: { label: "Discount Rate (0-100)" } },
            [
              _c("a-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.discount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "discount", $$v)
                  },
                  expression: "form.discount",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: "Coupon Count" } },
            [
              _c("a-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.count,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "count", $$v)
                  },
                  expression: "form.count",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: "Coupon Code Length" } },
            [
              _c("a-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.form.codeLength,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "codeLength", $$v)
                  },
                  expression: "form.codeLength",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: "Coupon Code Prefix (eg: APPSUMO-)" } },
        [
          _c("a-input", {
            attrs: { trim: "", type: "text" },
            model: {
              value: _vm.form.prefix,
              callback: function ($$v) {
                _vm.$set(_vm.form, "prefix", $$v)
              },
              expression: "form.prefix",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: "Coupon Expire Date" } },
        [
          _c("a-date-picker", {
            staticStyle: { width: "100%" },
            model: {
              value: _vm.form.endDate,
              callback: function ($$v) {
                _vm.$set(_vm.form, "endDate", $$v)
              },
              expression: "form.endDate",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }